import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/OurUSPAndImpact.css';
import QuoteModal from './QuoteModal';

/* Actual Indian Flag */
import indiaFlag from '../assets/india.svg';

/* Certification Assets */
import isoIcon from '../assets/01_ISO.png';
import cdscoIcon from '../assets/02_MEDICAL.png';
import md42Icon from '../assets/03_MEDICAL.png';
import msmeIcon from '../assets/04_MSME.png';
import dpiitIcon from '../assets/05_DPIIT.png';
import startupIndiaIcon from '../assets/06_STARTUP.png';


const OurUSPAndImpact = () => {

  const navigate = useNavigate();

  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);


  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };


  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };


  const handleRequestCallBack = () => {
    navigate('/contact');
  };


  /* ========================================================
     USP POINTS
  ======================================================== */

  const uspPoints = [
    {
      id: 1,
      title: 'Instant Service & Replacement',
      description:
        'An entirely new concept in India. Your clinic becomes the service center. Patients get instant replacement. No waiting. No frustration. No lost customers.',
      icon: 'fa-solid fa-bolt',
      iconType: 'fontawesome',
      highlight: 'Revolutionary Concept',
      color: '#4a90e2',
      stats: 'Same Day Resolution'
    },
    {
      id: 2,
      title: 'BYOB - Build Your Own Brand',
      description:
        'Your brand. Your identity. Your success. Create your own branded hearing aids with custom packaging, logo placement, and complete brand ownership.',
      icon: 'fa-solid fa-palette',
      iconType: 'fontawesome',
      color: '#d8bf8b',
      stats: '100% Private Label'
    },
    {
      id: 3,
      title: 'Made in India Advantage',
      description:
        'Proudly manufactured in India. Faster delivery, lower costs, complete supply chain control, and products designed specifically for Indian ears.',
      icon: indiaFlag,
      iconType: 'image',
      highlight: 'Local Manufacturing',
      color: '#e74c3c'
    },
    {
      id: 4,
      title: 'Affordable Pricing Model',
      description:
        'Premium quality at prices that make sense. Higher margins for partners. Affordable options for patients. Everyone wins.',
      icon: 'fa-solid fa-indian-rupee-sign',
      iconType: 'fontawesome',
      highlight: 'Market Disruptor',
      color: '#20c997'
    }
  ];


  /* ========================================================
     CERTIFICATIONS
  ======================================================== */

  const certifications = [
    {
      id: 1,
      name: 'ISO 13485:2016',
      title: 'Medical Devices Quality Management System',
      icon: isoIcon,
      badge: 'Certified',
      color: '#1a73e8'
    },
    {
      id: 2,
      name: 'CDSCO MD-5',
      title: 'Medical Device Manufacturing Licence',
      icon: cdscoIcon,
      badge: 'Licensed',
      color: '#e8710a'
    },
    {
      id: 3,
      name: 'MD-42',
      title: 'Medical Device Registration Certificate',
      icon: md42Icon,
      badge: 'Registered',
      color: '#2ecc71'
    },
    {
      id: 4,
      name: 'MSME',
      title: 'Micro, Small & Medium Enterprises',
      icon: msmeIcon,
      badge: 'Registered',
      color: '#9b59b6'
    },
    {
      id: 5,
      name: 'DPIIT',
      title:
        'Department for Promotion of Industry and Internal Trade',
      icon: dpiitIcon,
      badge: 'Recognized',
      color: '#3498db'
    },
    {
      id: 6,
      name: 'STARTUP INDIA',
      title: 'Government of India Startup Initiative',
      icon: startupIndiaIcon,
      badge: 'Recognized',
      color: '#ff9933'
    }
  ];


  /* ========================================================
     USP ICON RENDERER
  ======================================================== */

  const renderUSPIcon = (usp) => {

    if (usp.iconType === 'image') {
      return (
        <img
          src={usp.icon}
          alt="Indian National Flag"
          className="pahl-uai-x9-india-flag"
        />
      );
    }


    return (
      <i
        className={usp.icon}
        aria-hidden="true"
      ></i>
    );
  };


  return (

    <>

      <section
        id="our-usp-impact"
        className="pahl-uai-x9-section"
      >

        <div className="pahl-uai-x9-container">


          {/* =================================================
              SECTION HEADER
          ================================================= */}

          <div className="pahl-uai-x9-header">

            <span className="pahl-uai-x9-tagline">
              What Makes Us Different
            </span>


            <h2 className="pahl-uai-x9-title">

              Our{' '}

              <span className="pahl-uai-x9-title-highlight">
                Unique Advantage
              </span>

            </h2>


            <div className="pahl-uai-x9-title-underline"></div>


            <p className="pahl-uai-x9-subtitle">

              Four revolutionary concepts that are changing the
              hearing aid industry in India. Plus the impact we've
              created together with our partners.

            </p>

          </div>


          {/* =================================================
              USP CARDS
          ================================================= */}

          <div className="pahl-uai-x9-usp-section">

            <div className="pahl-uai-x9-usp-grid">


              {uspPoints.map((usp) => (

                <div
                  key={usp.id}
                  className="pahl-uai-x9-usp-card"
                >


                  <div
                    className="pahl-uai-x9-usp-icon-box"
                    style={{
                      background: `${usp.color}15`
                    }}
                  >

                    {renderUSPIcon(usp)}

                  </div>


                  <div className="pahl-uai-x9-usp-content">


                    <div className="pahl-uai-x9-usp-card-header">


                      <h3>
                        {usp.title}
                      </h3>


                      {usp.highlight && (

                        <span
                          className="pahl-uai-x9-usp-highlight-badge"
                          style={{
                            background: `${usp.color}20`,
                            color: usp.color
                          }}
                        >

                          {usp.highlight}

                        </span>

                      )}


                    </div>


                    <p>
                      {usp.description}
                    </p>


                    {usp.stats && (

                      <div
                        className="pahl-uai-x9-usp-stat"
                        style={{
                          color: usp.color
                        }}
                      >

                        {usp.stats}

                      </div>

                    )}


                  </div>

                </div>

              ))}


            </div>

          </div>


          {/* =================================================
              WHY PARTNERS TRUST US
          ================================================= */}

          <div className="pahl-uai-x9-trust-heading-section">

            <div className="pahl-uai-x9-trust-heading-content">

              <h3>
                Why Partners Trust Us
              </h3>

              <p>
                Certifications, regulatory compliance and
                recognized business credentials
              </p>

            </div>

          </div>


          {/* =================================================
              CERTIFICATION CARDS
          ================================================= */}

          <div className="pahl-uai-x9-cert-grid">


            {certifications.map((cert) => (

              <div
                key={cert.id}
                className="pahl-uai-x9-cert-card"
              >


                {/* Certification Image */}

                <div
                  className="pahl-uai-x9-cert-logo-box"
                  style={{
                    background: `${cert.color}12`,
                    borderColor: `${cert.color}30`
                  }}
                >

                  <img
                    src={cert.icon}
                    alt={`${cert.name} certification`}
                    loading="lazy"
                  />

                </div>


                {/* Certification Information */}

                <div className="pahl-uai-x9-cert-content">


                  <div className="pahl-uai-x9-cert-top">


                    <strong>
                      {cert.name}
                    </strong>


                    <span
                      className="pahl-uai-x9-cert-badge"
                      style={{
                        background: `${cert.color}18`,
                        color: cert.color,
                        borderColor: `${cert.color}35`
                      }}
                    >

                      {cert.badge}

                    </span>


                  </div>


                  <p>
                    {cert.title}
                  </p>


                </div>


              </div>

            ))}


          </div>


          {/* =================================================
              CTA
          ================================================= */}

          <div className="pahl-uai-x9-cta-box">


            <div className="pahl-uai-x9-cta-content">


              <h3>
                Ready to Partner with India's Most Innovative Brand?
              </h3>


              <p>
                Join 50+ successful clinics and distributors
                across the country
              </p>


              <div className="pahl-uai-x9-cta-actions">


                <button
                  type="button"
                  onClick={openQuoteModal}
                  className="pahl-uai-x9-cta-primary-btn"
                >

                  Become a Partner


                  <svg
                    className="pahl-uai-x9-cta-arrow"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-hidden="true"
                  >

                    <path
                      d="M5 12H19M19 12L13 6M19 12L13 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />

                  </svg>


                </button>


                <button
                  type="button"
                  onClick={handleRequestCallBack}
                  className="pahl-uai-x9-cta-secondary-btn"
                >

                  Request Call Back

                </button>


              </div>


            </div>


          </div>


        </div>

      </section>


      {/* Quote Modal */}

      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={closeQuoteModal}
      />


    </>

  );

};


export default OurUSPAndImpact;